<script setup lang="ts">
import type { ElementInterface, GroupInterface, QuerySliceInterface } from '@voix/types'
import type { PropType } from 'vue'
import { useSliceStore } from '@voix/store/sliceStore'
import { computed, provide } from 'vue'

const props = defineProps({
  elements: {
    type: Array as PropType<ElementInterface[]>,
    required: true,
  },
})

function setGroupElement(element: ElementInterface) {
  return element as GroupInterface
}
function setQuerySliceElement(element: ElementInterface) {
  return element as QuerySliceInterface
}
function shouldRenderElement(element: ElementInterface) {
  const sliceStore = useSliceStore()
  const config = sliceStore.getSlice(element.component)

  if (config?.xp_management === 'manual')
    return true

  return (
    (element.enabled && element.xp_status === 'approved')
    || (typeof element.xp_status === 'undefined' || typeof element.enabled === 'undefined') // legacy
  )
}
</script>

<template>
  <template
    v-for="(element) in elements"
    :key="element.id"
  >
    <template v-if="element.type === 'slice' && shouldRenderElement(element)">
      <VoixSliceLoop :element="element" />
    </template>
    <LazyVoixGroup
      v-if="element.type === 'group' && shouldRenderElement(element)"
      :group="setGroupElement(element)"
    />
    <VoixQuerySlice
      v-if="element.type === 'query' && shouldRenderElement(element)"
      :element="setQuerySliceElement(element)"
    />
  </template>
</template>
